import {applyMiddleware, combineReducers, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import ReduxThunk from 'redux-thunk';
import {persistReducer, persistStore} from 'redux-persist';
import localForage from 'localforage';
import * as reducers from './index';

const persistConfig = {
    key: 'root',
    storage: localForage
};

const configureStore = (initialState = {}) => {
    const rootReducer = combineReducers({...reducers});
    const persistedReducer = persistReducer(persistConfig, rootReducer);

    const middlewares = [ReduxThunk];
    const middlewareEnhancer = applyMiddleware(...middlewares);

    const composeEnhancers = composeWithDevTools;
    const enhancers = [middlewareEnhancer];
    const composedEnhancers = composeEnhancers(...enhancers);

    return createStore(persistedReducer, initialState, composedEnhancers);
}

export default (initialState = {}) => {
    let store = configureStore(initialState);
    let persistor = persistStore(store);
    return { store, persistor };
};